import React from "react";

import { LoadingSpinner } from "../../display/Loader/LoadingSpinner";
import { Box } from "../../primitive/Box/Box";
import { ButtonVariant } from "./Button";
import {
  getLoadingSpinnerBG,
  getLoadingSpinnerColor,
} from "./loadingSpinnerStyles";

/**
 * Loading spinner component for buttons
 */
export const ButtonSpinner: React.FC<{ variant: ButtonVariant }> = ({
  variant,
}) => {
  const color = getLoadingSpinnerColor(variant);
  const bg = getLoadingSpinnerBG(variant);

  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      bg={bg}
      alignItems="center"
      justifyContent="center"
      borderRadius="2"
    >
      <LoadingSpinner color={color} />
    </Box>
  );
};
